module.exports = __webpack_public_path__ + "static/media/icon2.85c74ca5.svg";